module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"heading":{"label":"Предложения от партнеров:","text":"наборы парфюмерных пробников 8 в 1"},"perfume":{"in_set":"Пробник доступен в наборе 8 в 1","not_in_set":"Набор пробников 8 в 1"},"view":{"set":"Смотреть набор пробников","sample":"Смотреть пробник"},"sets":{"one":"набор","few":"набора","many":"наборов","more":"Еще {total}","alt":"Другие наборы пробников Aroma Box"}}}')
  delete Component.options._Ctor
}
